<template>
  <b-modal id="modal_form"
           ref="modal_form"
           :title="modal_titulo"
           :ok-title="modal_botao"
           close-title="Fechar"
           cancel-title="Cancelar"
           size="lg"
           no-close-on-esc
           no-close-on-backdrop
           :ok-disabled=form.errors.any()
           v-model="showModal"
           @ok="handleOk">
    <form @submit.stop.prevent="handleOk">
      <b-row no-gutters class="pb-1">
        <b-col class="col-md-3">
          <b-input type="text" class="form-control" placeholder="Chave MDFe" v-model="form.chave" :maxlength="44"></b-input>
        </b-col>
        <b-col class="col-md-1">
          <b-btn @click="handleOk($event)" variant="secondary">
            Consultar
          </b-btn>
        </b-col>
        <b-col class="mb-1" offset="2" md="2">
          <b-input
              id="cdBarra"
              maxlength="31"
              autofocus
              type="text"
              placeholder="Código de barra"
              v-on:keyup.enter="onScan()"
              v-model="cd_barra"
              ref="cdBarra"
          ></b-input>
          <span>Qtde. caracteres código de barra: {{ qtdCaracteres() }}</span>
        </b-col>
        <b-col class="mb-1">
          <b-btn :disabled="loading" @click="onScan()" variant="secondary"
          >Escanear código</b-btn
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col md="1" class="px-1 mb-1">
          <span>Qtde. NFs</span>
          <b-input disabled type="text" v-model="qtde_nfs"></b-input>
        </b-col>
        <b-col md="1" class="px-1 mb-1">
          <span>Peso Bruto</span>
          <currency-input
              class="form-control"
              v-model="peso_bruto_total"
              placeholder="Peso total bruto"
              disabled
              :auto-decimal-mode="true"
              :currency="{ prefix: ' ' }"
              :distraction-free="getCurrency"
          />
        </b-col>
        <b-col md="4" style="display: flex; align-items: center">
          <span>Qtde. volumes bipados / Total de volumes : </span>
          <h4 class="ml-1">
            {{ this.qtd_volumes_bipados_total }}/{{ this.qtd_volumes_total }}
          </h4>
        </b-col>
      </b-row>
    </form>
    <div class="horizontal-scroll">
      <div class="loadingDataPosition">
        <div class="loadingData" v-if="loading"></div>
        <vuetable
            ref="vuetable"
            :api-mode="false"
            :data="notas_fiscais"
            :fields="fields"
            :css="css"
            :append-params="moreParams"
            :row-class="onRowClass"
            track-by="docfis_id"
            pagination-path=""
            @vuetable:load-error="onError"
            @vuetable:pagination-data="onPaginationData"
            @vuetable:loaded="onLoaded"
            detail-row-component="montagemcargachecamdfe-detalhes"
            @vuetable:cell-clicked="onDetail"
        >
          <template slot="actions" slot-scope="props">
            <div class="custom-actions">
              <a
                  @click="onDetail(props.rowData, null, null)"
                  v-b-tooltip
                  title="Ver detalhes"
              ><i class="fa fa-plus"></i
              ></a>
            </div>
          </template>
<!--          <template slot="status" slot-scope="props">-->
<!--            <span-->
<!--                class="badge badge-warning"-->
<!--                v-if="props.rowData.status.valor == 3"-->
<!--            >{{ props.rowData.status.descr }}</span-->
<!--            >-->
<!--            <span-->
<!--                class="badge badge-success"-->
<!--                v-if="props.rowData.status.valor == 2"-->
<!--            >{{ props.rowData.status.descr }}</span-->
<!--            >-->
<!--            <span-->
<!--                class="badge badge-warning"-->
<!--                v-if="props.rowData.status.valor == 1"-->
<!--            >{{ props.rowData.status.descr }}</span-->
<!--            >-->
<!--          </template>-->
            <template slot="quantidade" slot-scope="props">
              <span
              >{{ props.rowData.qtde_bipada }} /
                {{ props.rowData.qtde_total }}</span
              >
            </template>
            <template slot="num_fiscal" slot-scope="props">
              {{ props.rowData.num_fiscal }}
            </template>
<!--          <template slot="regiao_despesa" slot-scope="props">-->
<!--            <span v-if="props.rowData.regiao_despesa != null"-->
<!--            >{{ props.rowData.regiao_despesa.cd + " - " +-->
<!--            props.rowData.regiao_despesa.descr}}</span-->
<!--            >-->
<!--            <span v-if="props.rowData.regiao_despesa == null && props.rowData.regiao_despesa_rps != null"-->
<!--            >{{ props.rowData.regiao_despesa_rps.texto }}</span-->
<!--            >-->
<!--          </template>-->
        </vuetable>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal=false" variant="secondary">
          Fechar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>

import AvisoErros from '../components/AvisoErros'
import Vuetable from "../components/Vuetable";
import MontagemCargaChecaMdfeDetalhes from "./MontagemCargaChecaMdfeDetalhes.vue";
Vue.component("montagemcargachecamdfe-detalhes", MontagemCargaChecaMdfeDetalhes);

export default {
  components: {
    AvisoErros,
    Vuetable,
    MontagemCargaChecaMdfeDetalhes
  },
  props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
  },
  data () {
    return {
      dataExport: [],
      modal_titulo: '',
      permission: true,
      paste: false,
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      erroBip: false,
      errors_array: [],
      notas_fiscais: [],
      chaves_mdfes: [],
      qtde_nfs: 0,
      cd_barra: "",
      peso_bruto_total: 0,
      qtd_volumes_total: 0,
      qtd_volumes_bipados_total: 0,
      song: new Audio(),
      sucesso: require("../../public/audio/sucesso.mp3"),
      erro: require("../../public/audio/erro.mp3"),
      form: new Form({
            chave: '',
            manifesto_id: '',
            cd_barra: '',
          }
      ),
      fields: [
        {
          name: "__slot:num_fiscal",
          title: "N° Fiscal.",
        },
        {
          name: "__slot:quantidade",
          title: "Qtde.",
        },
        {
          name: "cnpj",
          title: "CNPJ",
        },
        {
          name: "razao_social",
          title: "Razão Social",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
    }
  },
  methods: {
    handleOk(e)
    {
      e.preventDefault();
      this.onUpdate();
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit('setVuetableFilterButton', false);
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onCreate() {
      this.loading = false;
      this.isDisabled = false;
      this.notas_fiscais = [];
      this.form.notas_fiscais = [];
      this.qtde_nfs = 0;
      this.peso_bruto_total = 0;
      this.qtd_volumes_total = 0;
      this.qtd_volumes_bipados_total = 0;
      this.modal_titulo = "Checar Manifesto";
      this.modal_botao = "Salvar";
      this.errors_array = [];
      this.cd_barra = "";
      this.erroBip = false,
      this.chaves_mdfes = [],
      this.form.reset();
      this.$refs.modal_form.show();
    },
    onUpdate()
    {
      // console.log(this.$snotify);
      this.chaves_mdfes.forEach((obj) => {
        if(obj == this.form.chave){
          this.tocaMusica(this.erro);     
          this.$snotify.error('MDFE já bipado' );
          this.erroBip = true;
        }
      });
      if(this.erroBip == false){

        this.chaves_mdfes.push(this.form.chave);

        this.loading = true;
        this.isDisabled = true;
        this.cd_barra = "";
        this.qtde_nfs = 0;
        this.peso_bruto_total = 0;
        this.qtd_volumes_total = 0;
        this.qtd_volumes_bipados_total = 0;
        this.notas_fiscais = [];
        this.form.post('/api/montagemcarga/checamdfe').then(response =>
        {
          new ReturnApi(response, this)
          this.modal_titulo = 'Checando manifesto : '+response.data[0].num_manifesto+'';
          this.form.manifesto_id = response.data[0].manifesto_id;
              response.data.forEach((item, i) => {
                this.notas_fiscais.push({
                  num_fiscal: item.num_fiscal,
                  cancelada: item.cancelada,
                  docfis_id: item.docfis_id,
                  volumes: item.volumes,
                  cnpj: item.cnpj,
                  razao_social: item.razao_social,
                  status: item.status,
                  qtde_total: item.qtde_total,
                  qtde_bipada: item.qtde_bipada,
                  chave: item.chave,
                })
                this.qtd_volumes_total += item.qtde_total;
                this.qtd_volumes_bipados_total += item.qtde_bipada;
                this.peso_bruto_total += item.peso_bruto_nf;
              })
            this.qtde_nfs = this.notas_fiscais.length;
            this.tocaMusica(this.sucesso);
            })
            .catch(errors =>
            {
              if(errors.tp_message == "success"){
              new ReturnApi(errors, this, true, null, null, false);
              this.tocaMusica(this.sucesso);
            } else {
              new ReturnApi(errors, this, true, null, null, false);
              this.tocaMusica(this.erro);
            }
              this.errors_array = '';
              this.errors_array = [];
              for (var property in errors) {
                if (errors.hasOwnProperty(property)) {
                  if (typeof(errors[property]) === 'object') {
                    errors[property].forEach((obj) => {
                      this.errors_array.push({
                        erro: obj
                      });
                    });
                  }
                }
              }
            });
      }
    },
    onScan() {
      this.errors_array = [];
      this.loading = true;
      this.isDisabled = true;
      this.isDisabledObs = true;
      this.form.nota = this.nota;
      this.form.cd_barra = this.cd_barra;
      // this.permite_digitar = false;
      this.form
          .post("/api/montagemcarga/bipvolumemdfe")
          .then((response) => {
            new ReturnApi(response, this);
            // this.permite_digitar = true;
              //Busca o index que vai ser alterado
              this.notas_fiscais.forEach((item, i) => {
                if (item.docfis_id == response.data.docfis_id) {
                  this.index = i;
                }
              });
              //Caso não tenha o index, faz o push para o array
              if (this.index == undefined) {
                this.notas_fiscais.push({
                    num_fiscal: response.data.num_fiscal,
                    cancelada: response.data.cancelada,
                    docfis_id: response.data.docfis_id,
                    volumes: response.data.volumes,
                    cnpj: response.data.cnpj,
                    razao_social: response.data.razao_social,
                    status: response.data.status,
                    qtde_total: response.data.qtde_total,
                    qtde_bipada: response.data.qtde_bipada,
                });
                //Caso tenha uma NF cancelada, vai abrir o modal avisando, mas vai deixar seguir normalmente
                if (response.data.cancelada !== false) {
                  this.tocaMusica(this.erro);
                  let obj = {
                    title: response.data.cancelada,
                    customCloseBtnText: "Fechar",
                    type: 'info',
                  }

                  this.$Simplert.open(obj);
                } else {
                  this.tocaMusica(this.sucesso);
                }
                // this.qtd_volumes_total += item.qtde_total;
                this.peso_bruto_total =
                    this.peso_bruto_total + response.data.peso_bruto_nf;
                this.qtde_nfs = this.notas_fiscais.length;
                this.$snotify.success(
                    "Nota fiscal N : " + response.data.num_fiscal + " bipada",
                    "Sucesso"
                );
              } else {
                //Caso tenha uma NF cancelada, vai abrir o modal avisando, mas vai deixar seguir normalmente
                if (response.data.cancelada !== false) {
                  this.tocaMusica(this.erro);

                  let obj = {
                    title: response.data.cancelada,
                    customCloseBtnText: "Fechar",
                    type: 'info',
                  }

                  this.$Simplert.open(obj);
                } else {
                  this.tocaMusica(this.sucesso);
                }
                //Faz o update da nota fiscal
                this.$set(this.notas_fiscais, this.index, response.data);
                this.qtd_volumes_bipados_total++;
                this.$snotify.success("Volume bipado", "Sucesso");
              }
            this.cd_barra = "";
            this.checaDisabledBotao();
          })
          .catch((errors) => {
            console.log(errors);
            // this.permite_digitar = true;
            if(errors.tp_message == "success"){
              new ReturnApi(errors, this, true, null, null, false);
              this.tocaMusica(this.sucesso);
            } else {
              new ReturnApi(errors, this, true, null, null, false);
              this.tocaMusica(this.erro);

              this.errors_array = "";
              this.errors_array = [];
              this.isDisabled = true;
              this.$refs.cdBarra.blur();
              this.cd_barra = "";
              for (var property in errors) {
                if (errors.hasOwnProperty(property)) {
                  if (typeof errors[property] === "object") {
                    errors[property].forEach((obj) => {
                      this.errors_array.push({
                        erro: obj,
                      });
                    });
                  }
                }
              }
            }
          });
    },
    tocaMusica(musica) {
      this.song.src = musica;
      this.song.play();
    },
    checaDisabledBotao() {
      this.notas_fiscais.forEach((item, i) => {
        if (item.status.valor == 1) {
          this.isDisabled = true;
        }
      });
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfis_id);
    },
    onRowClass(data, index) {
      return data.status.valor == 1 ? "table-warning" : "table-success";
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    checkPermissionBip() {
      return this.getPermissionFw('montagemcarga.digitaretiqueta');//
    },
    qtdCaracteres(){
      return this.cd_barra.length;
    }
  },
  computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  }
}
</script>
